import React from 'react';
import StageWithText from 'commonComponents/Stages/StageWithText/StageWithText';
import WorkAtWA from './WorkAtWA/WorkAtWA';
import LiveAndWork from './LiveAndWork/LiveAndWork';
import Benefits from './Benefits/Benefits';
import QuoteAndPhoto from './QuoteAndPhoto/QuoteAndPhoto';
import QuotePhoto from 'oldAssets/images/static_pages/career/Max-Mustermann.webp';
import Numbers from 'commonComponents/Numbers/Numbers';
import GalleryBanner from './GalleryBanner/GalleryBanner';

import Jobs from './Jobs/Jobs';
import styles from '../pages.module.scss';

const CareerPage = ({
  banner,
  overview,
  benefits,
  quote,
  numbers,
  liveAndWork,
  jobs,
  boxes
}) => {
  return (
    <div className={ styles.Page }>
      <StageWithText { ...banner } pageName="career" />
      <WorkAtWA { ...overview } />
      <Benefits { ...benefits } />
      <QuoteAndPhoto { ...quote } photo={ QuotePhoto } />
      <Numbers stats={ numbers } dividers={ false }
        additionalClass="career"
      />
      { GalleryBanner }
      <LiveAndWork { ...liveAndWork } />
      <Jobs header={ jobs.header } boxes={ boxes } />
    </div>
  );
};

export default CareerPage;
